<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover'
import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { SlidersHorizontal } from 'lucide-vue-next'
import { ref } from 'vue'

const { t } = useI18n()

defineProps<{
    filtersCount: number
    show: boolean
}>()

const emit = defineEmits<{
    open: []
    close: []
    reset: []
}>()

const isOpen = ref(false)
</script>

<template>
    <div class="relative">
        <Popover v-model:open="isOpen">
            <PopoverTrigger as-child>
                <Button
                    variant="outline"
                    @click="emit('open')"
                >
                    <SlidersHorizontal class="size-4 mr-2" />
                    Filter <span v-if="filtersCount" class="ml-2">({{ filtersCount }})</span>
                </Button>
            </PopoverTrigger>

            <PopoverContent align="end" class="w-56">
                <div class="flex justify-between items-center mb-3">
                    <p class="text-sm font-medium">Filters</p>
                </div>

                <Separator class="mb-3" />

                <div class="flex flex-col gap-2 items-start">
                    <slot />

                    <a href="#" class="inline-block pl-2 text-xs text-muted-foreground underline" @click.prevent="emit('reset')">{{
                        t('common.filters.resetBtn')
                    }}</a>
                </div>
            </PopoverContent>
        </Popover>
    </div>
</template>
